import { useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';
import ClipPlayerSkeleton from './components/ClipPlayerSkeleton';
import TimelineSkeleton from './components/TimelineSkeleton';
import TranscriptSkeletonContainer from './components/TranscriptSkeletonContainer';
import NavBarSkeleton from './components/NavBarSkeleton';
import { useEditorNavSlot } from '@/context/EditorNavSlotContext/EditorNavSlotContext';

const ClipSkeletonLoader = () => {
  const { navSlotEl, setHasNav } = useEditorNavSlot();

  // Portal the nav placeholder into the same full-width top slot the real ClipHeader uses, and
  // flag the layout so it drops the rail back button (the skeleton renders its own).
  useLayoutEffect(() => {
    if (navSlotEl) {
      setHasNav(true);
      return () => setHasNav(false);
    }
    return undefined;
  }, [navSlotEl, setHasNav]);

  return (
    <>
      {navSlotEl ? createPortal(<NavBarSkeleton />, navSlotEl) : <NavBarSkeleton />}
      <div className="flex size-full flex-col">
        <div className="flex h-4/5 w-full py-4">
          <div className="w-[32%]">
            <TranscriptSkeletonContainer />
          </div>
          <div className="flex-1">
            <ClipPlayerSkeleton />
          </div>
        </div>
        <div className="w-full flex-1 pr-2">
          <TimelineSkeleton />
        </div>
      </div>
    </>
  );
};

export default ClipSkeletonLoader;
